var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofa4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48173 14.8848C8.49382 14.7581 8.5 14.6298 8.5 14.5C8.5 12.2909 6.70914 10.5 4.5 10.5C4.33659 10.5 4.17548 10.5098 4.0172 10.5288C4.00579 10.354 4 10.1777 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 10.1777 19.9942 10.354 19.9828 10.5288C19.8245 10.5098 19.6634 10.5 19.5 10.5C17.2909 10.5 15.5 12.2909 15.5 14.5C15.5 14.6298 15.5062 14.7581 15.5183 14.8848H8.48173Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5272 15.9633C20.8901 15.2986 19.9934 14.8848 19 14.8848H17.0294C17.0101 14.7593 17 14.6308 17 14.5C17 13.1193 18.1193 12 19.5 12C20.8807 12 22 13.1193 22 14.5C22 15.0465 21.8247 15.552 21.5272 15.9633Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.5C2 15.0465 2.17533 15.552 2.4728 15.9633C3.10987 15.2986 4.00662 14.8848 5.00004 14.8848H6.97057C6.98995 14.7593 7 14.6308 7 14.5C7 13.1193 5.88071 12 4.5 12C3.11929 12 2 13.1193 2 14.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00002 16.3848C3.89544 16.3848 3 17.2802 3 18.3848V19.0001C3 19.8395 3.51704 20.5581 4.25 20.8548V22C4.25 22.4142 4.58579 22.75 5 22.75C5.41421 22.75 5.75 22.4142 5.75 22V21.0002H18.25V22C18.25 22.4142 18.5858 22.75 19 22.75C19.4142 22.75 19.75 22.4142 19.75 22V20.8548C20.483 20.5581 21 19.8395 21 19.0001V18.3848C21 17.2802 20.1046 16.3848 19 16.3848H5.00002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa4);
export default __webpack_public_path__ + "static/media/sofa-4.3f80614ee0fde2f225a7a5896d1e92d3.svg";
export { ForwardRef as ReactComponent };